// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.notification-container {
  display: flex;
  flex-direction: column;
  align-items: start;
  overflow: auto;
  clear: both;
  height: auto;
}

.home {
  display: flex;
  background-color: #F8FAFC;
}
.home .homeContainer {
  flex: 6 1;
}
.home .homeContainer .widgets,
.home .homeContainer .charts {
  display: flex;
  padding: 20px;
  gap: 20px;
}
.home .homeContainer .charts {
  padding: 5px 20px;
}
.home .homeContainer .listContainer {
  /* Let the page breathe – no surrounding card */
  box-shadow: none;
  -webkit-box-shadow: none;
  background: transparent;
  width: 100%;
  max-width: none; /* allow content to grow on large screens */
  padding: 0 24px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.home .homeContainer .listContainer .listTitle {
  font-weight: 500;
  color: gray;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/homepage-cons/Homepage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACI,aAAA;EACA,yBAAA;AACJ;AACI;EACE,SAAA;AACN;AACM;;EAEE,aAAA;EACA,aAAA;EACA,SAAA;AACR;AAEM;EACE,iBAAA;AAAR;AAGM;EACE,+CAAA;EACA,gBAAA;EACA,wBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA,EAAA,2CAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADR;AAGQ;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;AADV","sourcesContent":["\n.notification-container {\n  display: flex;\n  flex-direction: column;\n  align-items: start;  \n  overflow: auto;\n  clear: both;\n  height: auto;  \n}\n\n.home {\n    display: flex;\n    background-color: #F8FAFC;\n  \n    .homeContainer {\n      flex: 6;\n  \n      .widgets,\n      .charts {\n        display: flex;\n        padding: 20px;\n        gap: 20px;\n      }\n  \n      .charts {\n        padding: 5px 20px;\n      }\n  \n      .listContainer {\n        /* Let the page breathe – no surrounding card */\n        box-shadow: none;\n        -webkit-box-shadow: none;\n        background: transparent;\n        width: 100%;\n        max-width: none; /* allow content to grow on large screens */\n        padding: 0 24px;\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        gap: 24px;\n  \n        .listTitle {\n          font-weight: 500;\n          color: gray;\n          margin-bottom: 15px;\n        }\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
